// ─── ClientAppSyncAlert ──────────────────────────────────────────────────
// V97.82 — Bannière SaaS : signale à Anissa qu'une transition d'étape n'a PAS
// été synchronisée vers l'app cliente (après 3 retries échoués côté
// journeyState.syncClientAppStatus). Sans ce signal, la cliente restait
// bloquée sur son écran sans que personne le sache (risque n°1 de l'audit
// parcours 2026-07-03). Le bouton « Réessayer » rejoue retryClientAppSync.
//
// Cockpit praticienne : fonctionnel/dense (ambre d'alerte), pas la charte
// cliente. Se rend null s'il n'y a aucun marqueur en attente (cas normal).

import { useState } from 'react';
import { getClientAppSyncPending, retryClientAppSync } from '../services/journeyState';

export default function ClientAppSyncAlert({ journeyState, clientId, prenom, onRetried }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const pending = getClientAppSyncPending(journeyState);
  if (!pending) return null;

  async function handleRetry() {
    if (busy) return;
    setBusy(true);
    setMsg(null);
    try {
      const res = await retryClientAppSync(clientId);
      if (res?.ok) {
        setMsg({ tone: 'ok', text: 'Synchronisé.' });
        if (typeof onRetried === 'function') onRetried();
      } else {
        setMsg({ tone: 'err', text: "L'app cliente ne répond toujours pas. Réessaie dans un instant." });
      }
    } catch {
      setMsg({ tone: 'err', text: 'Échec — réessaie dans un instant.' });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
        margin: '0 0 16px',
        padding: '12px 16px',
        borderRadius: 10,
        background: '#f7efe0',
        border: '1px solid rgba(154,91,18,0.35)',
        color: '#7a4d12',
        fontSize: 13,
      }}
    >
      <span style={{ flex: 1, minWidth: 220, lineHeight: 1.45 }}>
        <strong>Synchro app cliente en échec.</strong>{' '}
        La dernière étape n&apos;a pas atteint l&apos;app{prenom ? ` de ${prenom}` : ''} — la cliente
        peut être bloquée sur son écran. Relance la synchronisation.
      </span>
      {msg && (
        <span style={{ fontSize: 12, color: msg.tone === 'ok' ? '#2E5E3E' : '#8a2a22' }}>
          {msg.text}
        </span>
      )}
      <button
        type="button"
        onClick={handleRetry}
        disabled={busy}
        style={{
          fontSize: 13,
          fontWeight: 500,
          padding: '7px 14px',
          borderRadius: 8,
          border: '1px solid #9a5b12',
          background: busy ? 'transparent' : '#9a5b12',
          color: busy ? '#9a5b12' : '#fff',
          cursor: busy ? 'default' : 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        {busy ? 'Synchronisation…' : 'Réessayer'}
      </button>
    </div>
  );
}
